import { render, staticRenderFns } from "./dui-progress-steps.vue?vue&type=template&id=48ec23d8&scoped=true&"
import script from "./dui-progress-steps.vue?vue&type=script&lang=js&"
export * from "./dui-progress-steps.vue?vue&type=script&lang=js&"
import style0 from "./dui-progress-steps.vue?vue&type=style&index=0&id=48ec23d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ec23d8",
  null
  
)

export default component.exports